import { render, staticRenderFns } from "./people_data_table_graduates.vue?vue&type=template&id=0c0554da"
import script from "./people_data_table_graduates.vue?vue&type=script&lang=js"
export * from "./people_data_table_graduates.vue?vue&type=script&lang=js"
import style0 from "./people_data_table_graduates.vue?vue&type=style&index=0&id=0c0554da&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports